/**
 * SectionTabs — horizontale Reiter fuer Tab-Navigation innerhalb eines Tabs (Phase 17).
 *
 * Genutzt im Paket-Tab (Stuck | Carrier | Waiting | Done) und im Lieferanten-Tab
 * (Huck | Helo | GlaWel | Sporttore | WFF). Optional mit Sub-Counts (z.B. "GlaWel 110 · 12 stuck").
 *
 * Pattern: controlled — Parent uebergibt activeId + onChange.
 */

import { AlertTriangle } from 'lucide-react';

export interface SectionTabItem {
  id: string;
  label: string;
  count?: number | null;
  /** Optional Sub-Count (z.B. Stuck-Notifications), wird in oranger Badge angezeigt */
  stuckCount?: number | null;
}

interface SectionTabsProps {
  items: SectionTabItem[];
  activeId: string;
  onChange: (id: string) => void;
  /** Optional: zusaetzliche Klassen am Container */
  className?: string;
}

export default function SectionTabs({ items, activeId, onChange, className }: SectionTabsProps) {
  return (
    <div
      className={`flex flex-wrap gap-1 border-b border-[#DAD9D9] ${className ?? ''}`}
      role="tablist"
    >
      {items.map((item) => {
        const isActive = item.id === activeId;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(item.id)}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors flex items-center gap-2 ${
              isActive
                ? 'border-[#1A1A1A] text-[#1A1A1A]'
                : 'border-transparent text-gray-500 hover:text-[#1A1A1A] hover:border-[#DAD9D9]'
            }`}
          >
            <span>{item.label}</span>
            {item.count != null && (
              <span
                className={`text-xs px-1.5 py-0.5 rounded ${
                  isActive ? 'bg-[#E9FF57] text-[#1A1A1A]' : 'bg-gray-100 text-gray-600'
                }`}
              >
                {item.count}
              </span>
            )}
            {item.stuckCount != null && item.stuckCount > 0 && (
              <span
                className="text-xs px-1.5 py-0.5 rounded bg-orange-100 text-orange-700 flex items-center gap-0.5"
                title={`${item.stuckCount} offene Stuck-Meldungen`}
              >
                <AlertTriangle className="w-3 h-3" />
                {item.stuckCount}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
